import { render, staticRenderFns } from "./Cartgory.vue?vue&type=template&id=7b60ff6e&scoped=true"
import script from "./Cartgory.vue?vue&type=script&lang=js"
export * from "./Cartgory.vue?vue&type=script&lang=js"
import style0 from "./Cartgory.vue?vue&type=style&index=0&id=7b60ff6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b60ff6e",
  null
  
)

export default component.exports